import { userSlice } from './user/user.slice';

type LoyaltyActions = typeof userSlice.actions;

// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
// As an added benefit, we are able to see which actions come from which slice in a central location
const { setUser, setLoyaltyLoading } = userSlice.actions;

export const loyaltyActions: LoyaltyActions = { setUser, setLoyaltyLoading };
